export default __webpack_public_path__ + "locales/bg/EmptyView.json?hash=067a6163119a7fe464bb415425ad9663";